import { render } from "./ConfigurationUpgradeSuccessful.vue?vue&type=template&id=1d46537d&scoped=true"
import script from "./ConfigurationUpgradeSuccessful.vue?vue&type=script&lang=js"
export * from "./ConfigurationUpgradeSuccessful.vue?vue&type=script&lang=js"

import "./ConfigurationUpgradeSuccessful.vue?vue&type=style&index=0&id=1d46537d&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d46537d"]])

export default __exports__